import { combineEpics } from 'redux-observable';
import { referPatient$ } from './referPatient$';

export default combineEpics(referPatient$);
